import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { createEntityAdapter } from '@reduxjs/toolkit'
import { useEffect } from 'react'
import { AnalyzerDropdown } from '../components/AnalyzerDropdown'
import { DefaultState } from '../../../../types'
import { getAllScript } from '../../../../redux/slices'
interface ScriptMinimal {
  id: number | string
  name: string
}

const ScriptSelectorWrapper = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllScript())
  }, [dispatch])

  const scripts = createEntityAdapter<ScriptMinimal>()
    .getSelectors()
    .selectAll(useSelector((state: DefaultState) => state.scripts))

  const scriptOptions = scripts.map((s) => ({
    label: s.name,
    value: s.id
  }))

  return (
    <AnalyzerDropdown
      name="scriptId"
      label="Script"
      options={scriptOptions}
      isRequired={true}
    />
  )
}

export default ScriptSelectorWrapper
